import React from "react";
import { twMerge } from "tailwind-merge";

interface RoundContainerProps {
  children: React.ReactNode;
  className?: string;
  withPadding?: boolean; // Optional prop to add internal padding
  shadow?: "none" | "sm" | "md" | "lg"; // Shadow intensity options
}

/**
 * A simplified container component with white background and rounded corners.
 * 
 * @param children - The content to display inside the container
 * @param className - Additional CSS classes to apply
 * @param withPadding - Whether to add default padding (p-4) inside the container
 * @param shadow - Shadow intensity: "none", "sm" (default), "md", or "lg"
 */
export function RoundContainer({
  children,
  className,
  withPadding = false, // Default to no padding
  shadow = "sm", // Default to small shadow
}: RoundContainerProps) {
  // Define shadow classes
  const shadowClasses = {
    none: "",
    sm: "shadow-sm",
    md: "shadow-md",
    lg: "shadow-lg"
  };

  return (
    <div
      className={twMerge(
        "bg-white rounded-lg", // Core styles
        shadowClasses[shadow], // Apply selected shadow
        withPadding && "p-4", // Add padding conditionally
        className // Allow custom classes to override defaults
      )}
    >
      {children}
    </div>
  );
}

export default RoundContainer; 